import { useState } from "react";
import { Smile } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const GROUPS: { key: string; label: string; emojis: string[] }[] = [
  {
    key: "smileys",
    label: "😀",
    emojis: [
      "😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","😉","😊","😇","🥰","😍","🤩",
      "😘","😗","😚","😙","😋","😛","😜","🤪","😝","🤗","🤭","🤫","🤔","🤐","😐","😴",
      "😪","😌","😔","😢","😭","😤","😠","😡","🤯","😳","🥵","🥶","😱","😰","😥","🤠",
      "😎","🤓","🧐","🙄","😬","🤥","😷","🤒","🤕","🤢","🤮","🥳","🥺","😈","👻","💀",
    ],
  },
  {
    key: "gestures",
    label: "👍",
    emojis: [
      "👍","👎","👌","🤌","✌️","🤞","🤟","🤘","👏","🙌","🤝","🙏","💪","🫶","👋","🤙",
      "☝️","👆","👇","👉","👈","✍️","💅","🦾","👀","🫡","🤲","🖐️","✋","🖖","👊","🤛",
    ],
  },
  {
    key: "hot",
    label: "🔥",
    emojis: [
      "🔥","⚡","✨","💥","🌟","⭐","💫","🚀","🎯","🏆","🥇","🎉","🎊","🎁","💎","👑",
      "💰","💸","🪙","📈","📊","🧨","🎶","🎵","🎧","🎤","🎬","📸","🎨","🕹️","⚽","🏀",
    ],
  },
  {
    key: "hearts",
    label: "❤️",
    emojis: [
      "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓","💗","💖",
      "💝","💌","💋","🌹","🌺","🌸","🌻","🌈","☀️","🌙","☁️","🍀","🌴","🍕","☕","🍾",
    ],
  },
];

export function EmojiPicker({
  onSelect,
  ariaLabel = "Add emoji",
}: {
  onSelect: (emoji: string) => void;
  ariaLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState(GROUPS[0]!.key);
  const active = GROUPS.find((g) => g.key === group) ?? GROUPS[0]!;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={ariaLabel} type="button">
          <Smile className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" side="top" className="w-[19rem] p-2">
        <div className="mb-2 flex items-center gap-1 border-b border-border pb-2">
          {GROUPS.map((g) => (
            <button
              key={g.key}
              type="button"
              onClick={() => setGroup(g.key)}
              className={`flex-1 rounded-md py-1 text-lg transition ${
                g.key === group ? "bg-muted" : "hover:bg-muted/60"
              }`}
              aria-label={g.key}
            >
              {g.label}
            </button>
          ))}
        </div>
        <div className="grid max-h-52 grid-cols-8 gap-0.5 overflow-y-auto">
          {active.emojis.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => {
                onSelect(e);
                setOpen(false);
              }}
              className="rounded-md py-1 text-xl leading-none transition hover:bg-muted"
            >
              {e}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
